/**
 * OpCon / Run Workflow Now — gated by LaunchDarkly `jhft_opcon_workflow_activation` (FR-C11 / FR-I1).
 *
 * When LD is unavailable, default is **false** (hide control until flag is explicitly on).
 * Optional Vite override: `VITE_ENABLE_WORKFLOW_ACTIVATION=true|false`.
 */

import { FeatureFlags } from "./launchdarkly-config";
import { isFeatureEnabled } from "./launchdarkly-helpers";

function viteOverride(): boolean | undefined {
	const raw = String(import.meta.env.VITE_ENABLE_WORKFLOW_ACTIVATION ?? "").trim().toLowerCase();
	if (raw === "false" || raw === "0" || raw === "no") return false;
	if (raw === "true" || raw === "1" || raw === "yes") return true;
	return undefined;
}

/** When false, Run Workflow Now must not appear in the UI (FR-I1). */
export function isWorkflowActivationFeatureEnabled(): boolean {
	const v = viteOverride();
	if (v === false) return false;
	if (v === true) return true;
	return isFeatureEnabled(FeatureFlags.OPCON_WORKFLOW_ACTIVATION, false);
}
